import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Navigation from './components/Navigation';
import ProtectedRoute from './components/ProtectedRoute';
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import ChatPage from './pages/ChatPage';
import LearningPage from './pages/LearningPage';
import EventsPage from './pages/EventsPage';
import DegreePlanPage from './pages/DegreePlanPage';
import ErrorBoundary from './components/ErrorBoundary';
import { FEATURE_FLAGS } from './config/featureFlags';
import './App.css';

function App() {
  const { LOGIN_ENABLED } = FEATURE_FLAGS;

  return (
    <ErrorBoundary>
      <AuthProvider>
        <Router>
          <div className="min-h-screen bg-gray-50">
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={<HomePage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route
                path="/chat"
                element={
                  <>
                    <Navigation />
                    <ChatPage />
                  </>
                }
              />

              {/* Conditionally Protected Routes */}
              <Route
                path="/learning"
                element={
                  LOGIN_ENABLED ? (
                    <ProtectedRoute>
                      <>
                        <Navigation />
                        <LearningPage />
                      </>
                    </ProtectedRoute>
                  ) : (
                    <>
                      <Navigation />
                      <LearningPage />
                    </>
                  )
                }
              />
              <Route
                path="/events"
                element={
                  LOGIN_ENABLED ? (
                    <ProtectedRoute>
                      <>
                        <Navigation />
                        <EventsPage />
                      </>
                    </ProtectedRoute>
                  ) : (
                    <>
                      <Navigation />
                      <EventsPage />
                    </>
                  )
                }
              />
              <Route
                path="/degree-plan"
                element={
                  LOGIN_ENABLED ? (
                    <ProtectedRoute>
                      <>
                        <Navigation />
                        <DegreePlanPage />
                      </>
                    </ProtectedRoute>
                  ) : (
                    <>
                      <Navigation />
                      <DegreePlanPage />
                    </>
                  )
                }
              />
            </Routes>
          </div>
        </Router>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
